import {InfoLayerButton, InfoLayerContainer, InfoLayerContent, InfoLayerText} from '../../assets/ts/components/infolayer';
import {useLanguage} from '../contexts/LanguageContext';

export function InfoLayer() {
    const [language] = useLanguage();

    function copyEmbeddingWebsiteURLToClipboard() {
        const parentURL = window.parent.location.href
        navigator.clipboard.writeText(parentURL).catch((error) => { alert(error) }).finally(() => { console.log('ok')});
    }

    return (
        <InfoLayerContainer>
            <InfoLayerContent>
                <InfoLayerText>{language.infolayer.text}</InfoLayerText>
                <InfoLayerButton onClick={copyEmbeddingWebsiteURLToClipboard}>{language.infolayer.button}</InfoLayerButton>
            </InfoLayerContent>
        </InfoLayerContainer>
    );
}